module.exports = __webpack_public_path__ + "static/img/11.ab3dcfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Personas/11.png
// module id = bzUI
// module chunks = 0